import { UserServiceClient } from 'fitbeat.api-clients';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Platform, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { SkillLevelSelection } from '../Bookings/components/SkillLevelSelection';
import { Button } from '../components';
import { getApiConfig } from '../config';
import { GoogleAnalytics } from '../services/google-analytics';
import Theme from '../theme';
import { toggleWorkoutProgramSelectModalVisible } from '../ui';
import { showError, showMessage } from '../ui';
import { UserDataConsumer } from '../utils';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { defaultScale } from '../utils/scaling';
class SkillLevel extends Component<any, any> {
  public userServiceClient = new UserServiceClient(
    getApiConfig(), fetch, console.log, new AuthTokenBuilder(), new GoogleAnalytics());

  constructor(props) {
    super(props);
    const { t, user: { userProfile } } = this.props;
    this.state = {
      isLoading: false,
      error: null,
      skillLevel: userProfile.skillLevel ? userProfile.skillLevel : null,
    };
  }

  public saveUserSkillLevel = async (skillLevel) => {
    const { t, user: { userProfile, userProfileService } } = this.props;
    this.setState({ isLoading: true });
    try {
      userProfile.skillLevel = this.state.skillLevel;
      await userProfileService.updateUserProfile(userProfile);
      this.setState({ isLoading: false });
      this.props.navigation.navigate('Goals');
      showMessage(t('skillLevelUpdatedSuccess'));
      this.props.closeSkillLevelModal();
    } catch (error) {
      this.setState({ isLoading: false });
      showError(t('skillLevelUpdatedFailure'));
    }
  }

  public setStillLevel = async (skillLevel) => {
    await this.setState({ skillLevel });
  }

  public render() {
    const { t } = this.props;
    return (
      <View style={styles.container} className='full-height'>
        <View style={styles.body}>
          <SkillLevelSelection
            skillLevel={this.state.skillLevel}
            onPress={this.setStillLevel}
          />
        </View>
        <View style={styles.footer}>
          <Button
            fontColor={Theme.WHITE}
            isLoading={this.state.isLoading}
            onPress={this.props.handleSubmit(this.saveUserSkillLevel)}
            title={`Update`}
          />
        </View>
      </View>
    );
  }
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
    paddingVertical: defaultScale(15),
    ...Platform.select({
      web: {
        paddingHorizontal: 30,
        paddingVertical: 15,
        height: '80vh',
      },
    }),
  },
  body: {
    flex: 1,
    justifyContent: 'center',
  },
  nutritionLogo: {
    alignSelf: 'center',
    width: defaultScale(40),
    height: defaultScale(40),
    margin: defaultScale(2.5),
    marginHorizontal: defaultScale(10),
    marginVertical: defaultScale(20),
    marginTop: defaultScale(50),
  },
  footer: {
    alignContent: 'flex-end',
    justifyContent: 'flex-end',
  },
});

const mapStateToProps = (state) => {
  return {
    isModalVisible: state.ui.workoutProgramSelectModalVisible,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleWorkoutProgramSelectModalVisible: (visible) => dispatch(toggleWorkoutProgramSelectModalVisible(visible)),
  };
};

const SkillLevelUser = UserDataConsumer(SkillLevel);
const SkillLevelRedux = connect(mapStateToProps, mapDispatchToProps)(SkillLevelUser);
const SkillLevelTranslate = translate(['settings'], { wait: true })(SkillLevelRedux);
const SkillLevelForm = reduxForm({ form: 'GoalsAndSkillsForm' })(SkillLevelTranslate);
export default SkillLevelForm;
